import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getSessionAuth, resolveHomePath } from './session';

/**
 * Requires session auth. Optionally requires org roles.
 */
export function RequireAuth({ children, roles }) {
    const auth = getSessionAuth();
    const location = useLocation();

    if (!auth.auth || !auth.uid || !auth.token) {
        return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
    }

    if (roles?.length) {
        const effective = [
            auth.orgRole,
            auth.role,
            auth.platformAdmin ? 'platform_admin' : null,
        ].filter(Boolean);
        const ok = roles.some((r) => effective.includes(r))
            || (roles.includes('instructor') && (auth.role === 'teacher' || auth.orgRole === 'org_admin'))
            || (roles.includes('org_admin') && auth.platformAdmin);
        if (!ok) {
            return <Navigate to={resolveHomePath(auth)} replace />;
        }
    }

    return children;
}

/** Redirect authenticated users from / to their role home */
export function RoleHomeRedirect() {
    const auth = getSessionAuth();
    if (!auth.auth || !auth.token) return <Navigate to="/signin" replace />;
    return <Navigate to={resolveHomePath(auth)} replace />;
}

export function useLegacyPathRedirects() {
    const location = useLocation();
    useEffect(() => {
        // Reserved for analytics of legacy path usage
    }, [location.pathname]);
}
